import React from 'react';
import './ResetPasswordExpired.scss';
import Copyright from './Copyright';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const ResetPasswordExpired: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="reset-password-expired-page pp-font-geist">
            <div className="reset-password-expired-page__wrapper">
                <div className="d-flex justify-content-center reset-password-expired-page__logo">
                    <img
                        alt='mooveno-logo'
                        src={`/login/mooveno-logo-dark.svg`}
                        style={{ width: 182, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                    />
                </div>
                <Card className="reset-password-expired-page__card">
                    <div className="reset-password-expired-page__header">
                        <img
                            alt='expired-token'
                            className="reset-password-expired-page__icon"
                            src={`/sidebar/orders-sidebar.svg`}
                        />
                        <h1 className="reset-password-expired-page__title">Token wygasł</h1>
                        <p className="reset-password-expired-page__subtitle">Link do resetowania hasła wygasł lub jest nieprawidłowy.</p>
                    </div>
                    <p className="reset-password-expired-page__hint">
                        Linki resetujące są ważne przez 15 minut.<br />
                        Możesz poprosić o nowy link resetujący.
                    </p>
                    <div className="reset-password-expired-page__actions">
                        <Button
                            className="reset-password-expired-page__submit"
                            label={"Poproś o nowy link"}
                            onClick={() => navigate('/reset-password/')}
                        />
                        <Button
                            className="reset-password-expired-page__secondary-button"
                            label={"Powrót do logowania"}
                            icon="pi pi-arrow-left"
                            iconPos="left"
                            onClick={() => navigate('/login/')}
                        />
                    </div>
                </Card>
                <Copyright className="reset-password-expired-page__copyright" />
            </div>
        </div>
    );
};

export default ResetPasswordExpired; 